import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";

ReactDOM.render(
    <ErrorBoundary>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </ErrorBoundary>,
    document.getElementById('root')
);
// test
reportWebVitals();
